export default {
  name: 'test',
  hostnames: ['cinchborrowertest.fmm.com', 'cinchborrowertest.azurefd.net'],
  values: {
    FUNCTION_URL: 'https://func-cinch-serverside-test.azurewebsites.net/api/',
    API_URL: 'https://app-cinch-borrower-test.azurewebsites.net/api/',
    AUTH_DOMAIN: 'logintest.fmm.com',
    CLIENT_ID: 'sMZyVF6fTqPwyTJqGXmLGXzsppByYifV',
    AI_INSTRUMENTATION_KEY: '8e60ab53-730f-477c-b154-f3aa67606265',
    DEPLOY_ENV: 'test',
    LO_URL: 'https://cinchtest.fmm.com',
    LOGROCKET_APPID: 'fmm/cinch-borrower-dev',
  },
};
